import React, { Component } from 'react';

import ContentWrapper from '../../components/ContentWrapper';
import PageTitle from '../../components/PageTitle';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { Link } from 'react-router-dom';

import moment from 'moment';

import { 
  loadEvents,
  removeEvent,
} from '../../reducers/events';

import ChevronUpIcon from '@atlaskit/icon/glyph/chevron-up';
import ChevronDownIcon from '@atlaskit/icon/glyph/chevron-down';

class Events extends Component {

  state = {
    filter: 'all',
    filteredEvents: [],
    sort: null,
    sortType: null
  }

  componentDidMount = () => { 
    this.changeFilter(this.state.filter);
  }

  componentDidUpdate = (prevProps, prevState) => {
    if(!this.props.isLoadingEvents && prevProps.isLoadingEvents !== this.props.isLoadingEvents) {
      this.changeFilter(this.state.filter);
    }
  }

  changeFilter = (filter) => {
    this.setState({filter});

    switch(filter) {
    case 'all':
      this.setState({filteredEvents: this.props.events});
      break;
    case 'incoming':
      let filteredEventsIncoming = this.props.events.filter((event) => {
        const now = moment();
        const eventIncoming = moment(event.schedule.date_start).utc();

        if(now.isBefore(eventIncoming, 'hour')) {
          return true;
        }

        return false;
      });
      this.setState({filteredEvents: filteredEventsIncoming});
      break;
    case 'ongoing':
      let filteredEventsOngoing = this.props.events.filter((event) => {
        const now = moment().utc();
        const eventDateStart = moment(event.schedule.date_start).utc();
        const eventDateEnd = moment(event.schedule.date_end).utc();

        if(now.isBetween(eventDateStart, eventDateEnd)) {
          return true;
        }

        return false;
      });
      this.setState({filteredEvents: filteredEventsOngoing});
      break;
    case 'finished':
      let filteredEventsFinished = this.props.events.filter((event) => {
        const now = moment();
        const eventEnd = moment.utc(event.schedule.date_end, 'YYYY-MM-DD[T]HH:mm[Z]');

        if(now.isAfter(eventEnd)) {
          return true;
        }

        return false;
      });
      this.setState({filteredEvents: filteredEventsFinished});
      break;
    default:
      break;
    }
  }

  changeSort = (sort, sortType) => {
    this.setState({sort, sortType}, () => {

      let filteredEvents = this.state.filteredEvents;

      if(this.state.sort === 'from') {
        filteredEvents.sort((eventA, eventB) => {
          return this.state.sortType === 'ASC' ? moment.utc(eventA.schedule.date_start).diff(moment.utc(eventB.schedule.date_start)) : moment.utc(eventA.schedule.date_start).diff(moment.utc(eventB.schedule.date_start)) * -1;
        });
      }
      if(this.state.sort === 'to') {
        filteredEvents.sort((eventA, eventB) => {
          return this.state.sortType === 'ASC' ? moment.utc(eventA.schedule.date_end).diff(moment.utc(eventB.schedule.date_end)) : moment.utc(eventA.schedule.date_end).diff(moment.utc(eventB.schedule.date_end)) * -1;
        });
      }

      this.setState({filteredEvents});
    });
  }

  removeEvent = (event) => {
    if(window.confirm(`Do you want to remove ${event.event_title}?`)){
      this.props.removeEvent(event.event_id, ()=> {
        this.props.loadEvents();
      });
    }
  }

  render() {
    return (
      <ContentWrapper>
        <div className="inner-content">
          <PageTitle>Events</PageTitle>
          <div className="container-fluid">
            <div className="row" role="toolbar" aria-label="Toolbar with button groups">

              <div className="input-group col-md-4">
                <div className="btn-group" role="group" aria-label="Basic example">
                  <button type="button" className={`btn ${this.state.filter === 'all' ? `btn-secondary` : `btn-outline-secondary`}`} onClick={() => this.changeFilter('all')}>All</button>
                  <button type="button" className={`btn ${this.state.filter === 'incoming' ? `btn-secondary` : `btn-outline-secondary`}`} onClick={() => this.changeFilter('incoming')}>Incoming</button>
                  <button type="button" className={`btn ${this.state.filter === 'ongoing' ? `btn-secondary` : `btn-outline-secondary`}`} onClick={() => this.changeFilter('ongoing')}>Ongoing</button>
                  <button type="button" className={`btn ${this.state.filter === 'finished' ? `btn-secondary` : `btn-outline-secondary`}`} onClick={() => this.changeFilter('finished')}>Finished</button>
                </div>
              </div>

              <div className="col-md-4 offset-md-4">
                <Link to="/events/add" className="btn btn-primary float-right">Add Event</Link>
              </div>

            </div>
            
            <table className="table table-striped table-hover">
              <thead>
                <tr>
                  <th scope="col" colSpan="1" >Event</th>
                  <th scope="col" colSpan="1" >From <ChevronUpIcon primaryColor={this.state.sort === 'from' && this.state.sortType === 'ASC' ? '#007bff' : '#CCC'} onClick={() => this.changeSort('from', 'ASC')}/><ChevronDownIcon primaryColor={this.state.sort === 'from' && this.state.sortType === 'DESC' ? '#007bff' : '#CCC'} onClick={() => this.changeSort('from', 'DESC')}/></th>
                  <th scope="col" colSpan="1" >To <ChevronUpIcon primaryColor={this.state.sort === 'to' && this.state.sortType === 'ASC' ? '#007bff' : '#CCC'} onClick={() => this.changeSort('to', 'ASC')}/><ChevronDownIcon primaryColor={this.state.sort === 'to' && this.state.sortType === 'DESC' ? '#007bff' : '#CCC'} onClick={() => this.changeSort('to', 'DESC')}/></th>
                  <th scope="col" width="200">Actions</th>
                </tr>
              </thead>
              {this.props.isLoadingEvents &&
                <tbody>
                  <tr>
                    <td colSpan="4" className="text-center"><em>Loading Events</em></td>
                  </tr>
                </tbody>
              }
              {!this.props.isLoadingEvents && this.state.filteredEvents.length === 0 &&
                <tbody>
                  <tr>
                    <td colSpan="4" className="text-center"><em>0 Events</em></td>
                  </tr>
                </tbody>
              }
              {this.state.filteredEvents &&
                <tbody>
                  {this.state.filteredEvents.map((event, idx) => {
                    return (
                      <tr key={`event-${idx}`}>
                        <td>
                          <strong>{event.event_title}</strong>
                        </td>
                        <td>
                          {event.schedule.date_start &&
                            <span>{moment(event.schedule.date_start).utc().format("MM-DD-YYYY, hh:mm")}</span> 
                          }
                        </td>
                        <td>
                          {event.schedule.date_end &&
                            <span>{moment(event.schedule.date_end).utc().format("MM-DD-YYYY, hh:mm")}</span>
                          }
                        </td>
                        <td>
                          <Link to={`/events/${event.event_id}`} className="btn btn-outline-secondary btn-sm">Edit</Link>&nbsp;
                          <button className="btn btn-outline-danger btn-sm" onClick={() => this.removeEvent(event)}>Remove</button>&nbsp;
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              }
            </table>
          </div>
        </div>
      </ContentWrapper>
    )
  }
}


const mapStateToProps = state => ({
  events: state.events.events,
  isLoadingEvents: state.events.isLoadingEvents
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      loadEvents,
      removeEvent,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(Events);


// WEBPACK FOOTER //
// ./src/modules/Events/Events.js